import { call, put } from 'redux-saga/effects';
import Http from '../../../libs/Http';

export function* fetchHealthData(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.get, '/health/data', {
    query: {}
  });
  yield put({
    type: 'SET_HEALTH_DATA',
    payload: data
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* clearCache(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.get, '/health/clearCache', {
    query: {}
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* restart(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.get, '/admin/restart', {
    query: {}
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export default function* ({ takeFirst, takeLatest, takeEvery }) {
  yield [
    takeFirst('FETCH_HEALTH_DATA', fetchHealthData),
    takeEvery('CLEAR_CACHE', clearCache),
    takeEvery('SYNC_RESTART', restart),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Health/Health.sagas.js